export default __webpack_public_path__ + "static/media/deltaIcon.babba7f8.png";